import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import deleteimg from "../../images/common/delete.png"
import deleteimgblue from "../../images/common/deleteBlue.png"
import editimg from "../../images/common/pencil.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import * as FileSaver from "file-saver";
import { exportToExcel } from '../../utils/exportMethods'; 
import CircleSign from '../ui/CircleSign';
import ConfirmationModal from '../ui/ConfirmationModal';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import '../../css/Buttons.css';
import {config} from '../../constants';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import ConfirmationDelete from '../ui/ConfirmationDelete';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL; //"http://localhost:52344";

const dataSource = createStore({
  key: "roleId",
  loadUrl: `${url}/RoleMicroservice`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/RoleMicroservice`, ///DeleteOrder
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const appName = "";
const LoadSubmenu = (section) =>{
  history.push(appName+'/admin' + (section != '' ? '/'+section : '')) ;
}

const exportRolesToExcel = async (apiData, fileName) => {
  const headers = [
    { header: 'Name', key: 'name', autoFit: true },
    { header: 'Can manage agencies', key: 'canManageAgency', autoFit: true },
    { header: 'Can manage agency fees', key: 'canManageAgencyFees', autoFit: true },
    { header: 'Can manage agency networks', key: 'canManageAgencyNetwork', autoFit: true },
    { header: 'Can manage zones', key: 'canManageZone', autoFit: true },
    { header: 'Can manage subzones', key: 'canManageSubzone', autoFit: true },
    { header: 'Can manage country/region', key: 'canManageCountry', autoFit: true },
    { header: 'Can manage Maisons', key: 'canManageMaisons', autoFit: true },
    { header: 'Can manage opening input period per Maisons', key: 'canManageOpeningInputPeriodPerMaisons', autoFit: true },
    { header: 'Can manage exchange rates', key: 'canManageExchangeRate', autoFit: true },
    { header: 'Can manage airport names', key: 'canManageAirportNames', autoFit: true },
    { header: 'Can manage positions', key: 'canManagePositions', autoFit: true },
    { header: 'Can manage vehicles', key: 'canManageVehicles', autoFit: true },
    { header: 'Can manage publishers/vendors', key: 'canManagePublishersVendors', autoFit: true },
    { header: 'Can manage profiles', key: 'canManageProfiles', autoFit: true },
    { header: 'Can manage users', key: 'canManageUsers', autoFit: true },
    { header: 'Can manage roles', key: 'canManageRoles', autoFit: true },
    { header: 'Can access budget list', key: 'canAccessBudgetList', autoFit: true },
    { header: 'Can manage budget form', key: 'canManageBudgetForm', autoFit: true },
    { header: 'Can share reports', key: 'canShareReports', autoFit: true },
    { header: 'Can export to Excel', key: 'canExportToExcel', autoFit: true },
    { header: 'Can create reports', key: 'canCreateReports', autoFit: true },
    { header: 'Can save reports', key: 'canSaveReports', autoFit: true }
  ];

  await exportToExcel(headers, apiData, 'roles_extract', 'Roles Extract');
};

class Role extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
        
        this.state = {
          showConfirmationModal: false,
          showModal: false,
          showEditModal: false,
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          value:'1',
          RightsSelected: [],
          showUserMenu: true,
          showProfileMenu: true,
          showRoleMenu: true,
          fullscreen:false,
          roles:[],
          validation:true,
          roleValidation:true,
          editValidation:true,
          duplicatedValidation:true,
          selectedRowName:'',
          showConfirmationDelete: false,
          selectedId:"",
          selectedName:"",
        };
        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
      }

      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }

      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
      }

      closeConfirmationModal = ()=>{
        this.setState({ showConfirmationModal: false });
      }
  
      doubleCloseModals = () => {
        const { state } = this.props.location;
        if (typeof state !== "undefined" && state != null) {
          if (state.showNewPopup) {
            history.push({ pathname: "/admin", state: { showNewPopup: false } });
          }
        }
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
          value: "1"
        });
      };

     // to refresh our datagrid table and close all modals
     useRefresh = () => {
        this.dataGrid.useRefresh();
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      }

    handleClose = () =>{
      this.setState({ showConfirmationModal: true });
    }

    openModal = () => {   
      this.setState({duplicatedValidation: true,showModal:true, validation: true});
      this.state.RightsSelected = [];
      }

    handleEditClose = () =>{
        this.setState({ showConfirmationModal: true });
      }
    
    openEditModal = (e) => {
      this.setState({duplicatedValidation: true,showEditModal:true,  editValidation:true});

      this.refs.EditName.value = e.row.data.name;
      this.setState({selectedRowName: e.row.data.name})
      this.state.RightsSelected = [];
      console.log(e.row.data.roleId);
      this.setState({selectedRowIndex: e.row.data.roleId});

      apiClient.get(`${url}/RoleMicroservice/${e.row.data.roleId}`)
      .then(response => {
        const data = response.data;
        this.state.RightsSelected = data.map(obj => {return obj.name});
        this.handleChange(null,'1');
      });
    }


  onCreateRole = () => {
    this.setState({ duplicatedValidation: true })

    if (this.refs.Name.value == "") {
      this.setState({ validation: false })
      return;
    } else {
      this.setState({ validation: true })
    }
    if (this.state.RightsSelected.length == 0) {
      this.setState({ roleValidation: false })
      return;
    } else {
      this.setState({ roleValidation: true })
    }

    let RoleInfo = {
      Name: this.refs.Name.value.trim(),
      RightsIds: this.state.RightsSelected
    };

    apiClient.post(`${url}/RoleMicroservice`, RoleInfo)
      .then(response => {
        if (response) {
          const data = response.data;
          if (data.statusCode == 400) {
            this.setState({ duplicatedValidation: false })
            return;
          } else {
            toast.success('Role has been created');
            this.doubleCloseModals();
            const { state } = this.props.location;
            if (typeof (state) !== 'undefined' && state != null) {
              if (state.showNewPopup) {
                history.push({ pathname: "/admin", state: { 'showNewPopup': false } });
              }
            } else {
              this.useRefresh();
            }
          }
        }
      });
  }

  onEditRole = () => {
    this.setState({ duplicatedValidation: true })
    let name = this.refs.EditName.value.trim();
    let currentRole = this.refs.EditName.value;

    if (currentRole == "") {
      this.setState({ editValidation: false })
      return;
    } else {
      this.setState({ editValidation: true })
    }
    if (this.state.RightsSelected.length == 0) {
      this.setState({ roleValidation: false })
      return;
    } else {
      this.setState({ roleValidation: true })
    }

    let RoleInfo = {
      RoleId: this.state.selectedRowIndex,
      Name: name,
      RightsIds: this.state.RightsSelected
    };

    apiClient.put(`${url}/RoleMicroservice`, RoleInfo)
      .then(response => {
        if (response) {
          const data = response.data;
          if (data.statusCode == 400) {
            this.setState({ duplicatedValidation: false })
            return;
          } else {
            toast.success('Role has been updated');
            this.doubleCloseModals();
            this.useRefresh();
          }
        }
      });
  }
  
  onExportToExcel = () => {
    apiClient.get(`${url}/RoleMicroservice/Export`)
      .then(response => {
        if (response) {
          const data = response.data;
          exportRolesToExcel(data);
          toast.success('Roles Excel export file has been generated');
        }
      });
  }

    handleChange = (event, newValue) => {
      this.setState({value:newValue});

      var array = this.state.RightsSelected;

      setTimeout(function () {

        for(var i=0; i < array.length; i++){
          try {
            var str = array[i];
            var chk = document.getElementById(str); 
            chk.checked = true;
          } catch (error) {
          }
        }
      }, 100);
    };
  
    saveChkState = (checked) => {
      if (this.state.RightsSelected.indexOf(checked.target.id) > -1){
        var array = this.state.RightsSelected;
        var index = array.indexOf(checked.target.id);
        if (index !== -1) {
          array.splice(index, 1);
          this.state.RightsSelected = array;
        }
      }else{
        this.state.RightsSelected.push(checked.target.id);
      }
    }

    componentDidMount(){    
      const decoded = jwt_decode(localStorage.getItem('token'));
      this.setState({
        showUserMenu: decoded.can_manage_users  === "true",
        showProfileMenu: decoded.can_manage_profiles === "true",
        showRoleMenu: decoded.can_manage_roles === "true",
        can_export_to_excel: decoded.can_export_to_excel === "true"
      });
      const { state } = this.props.location;
      if (typeof(state) !== 'undefined' && state != null) {
      if(state.showNewPopup){
        this.setState({showModal:true});
      }
     }
    }

    CheckCanDelete = (e) =>{
      return e.row.data.canDelete;
    }

    CheckCannotDelete = (e) =>{
      return !e.row.data.canDelete;
    }

    showConfirmationDelete = (e) =>{
      console.log(e.row)
      this.setState({ showConfirmationDelete: true, selectedId:e.row.key, selectedName:e.row.data.name });
   }

    hideConfirmationDelete = () =>{
      this.setState({ showConfirmationDelete: false });
   }

  onCatchDelete = () => {
    let selectedProfileId = this.state.selectedId;

    apiClient.delete(`${url}/RoleMicroservice`,
      {
        headers: {
          'key': selectedProfileId
        }
      })
      .then(response => {
        if (response) {
          const data = response.data;
          let msg = "Role has been deleted";
          toast.success(msg);
          this.hideConfirmationDelete();
          this.useRefresh();
        }
      });
  }

  render() {
    const columns = [
      { dataField: "name", caption: "Name", width: "100%" },
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "Delete", icon: deleteimgblue, style: { paddingTop: "-2rem" }, visible: this.CheckCanDelete, name: "delete", onClick: this.showConfirmationDelete},
      {text: "Delete", icon: deleteimg, style: { paddingTop: "-2rem" }, visible: this.CheckCannotDelete, name: "delete", disabled: true, onClick: null},
      // Additional buttons for Profiles component
    ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>
            Roles Management
          </span>
        </div>
        <div className="div-section-actions push">
          <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header" onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Role</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-body">
        <div className="div-body-submenu">
          <div className={this.state.showUserMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('useradministration')} >              
                <div class="div-submenu-label">
                    <label>Users</label>
                </div> 
            </div>
            <div className={this.state.showProfileMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('profiles')} >              
                <div class="div-submenu-label">
                    <label>Profiles</label>
                </div> 
            </div>
            <div className={this.state.showRoleMenu ? "div-submenu-link active" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('roles')} >              
                <div class="div-submenu-label">
                    <label>Roles</label>
                </div> 
            </div>
          </div>
        <div  className="div-padding-20 div-grid-result">

        <CustomDataGrid
              dataSource={dataSource}
              keyExpr="roleId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              onSelectionChanged={this.selectionChanged}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>
      </div>

      <Modal show={this.state.showModal} onHide={this.handleClose} size="roles" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New Role</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><span className='mandatory-style'>This Role already exists, your updates cannot be saved.</span></Row>  } 
        {!this.state.validation && <Row className="mb-3 col-md-12"><span className='mandatory-style'>Mandatory fields are missing. Saving of the Role form is not allowed.</span></Row>  }
        {!this.state.roleValidation && <Row className="mb-3 col-md-12"><span className='mandatory-style'>At least one right has to be selected.</span></Row>  }    
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.validation ? "normal-title" : "validation-title"} font-size-12`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="Name" placeholder="Name" className={`${!this.state.validation && "validation-control"}`} />
            </Form.Group>
            {!this.state.validation && <p className="p-required">Required</p>}
          </Row>
        <Row>
        <Form.Group className="mb-3 col-md-12"></Form.Group>
        </Row>
          <span className='set-right'>
          Set the rights that apply to this role among the tabs :
          </span>        
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={this.state.value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={this.handleChange} aria-label="tabs">
                  <Tab className='custom-tab' label="Administration" value="1" />
                  <Tab className='custom-tab' label="Inputting" value="2" />
                  <Tab className='custom-tab' label="Reporting" value="3" />
                </TabList>
              </Box>

              <TabPanel value="1" className='role-container font-size-12'>
                <div className='display-flex'>
                  <div>
                    <Form.Label className='title-color'>Agencies</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox">
                        <Form.Check id="can_manage_agency" type="checkbox" ref="can_manage_agency" label="Can manage agencies" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox1">
                        <Form.Check id="can_manage_agency_fees" type="checkbox" ref="can_manage_agency_fees" label="Can manage agency fees" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox2">
                        <Form.Check id="can_manage_agency_network" type="checkbox" ref="can_manage_agency_network" label="Can manage agency networks" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                    <Form.Group className="mb-3 col-md-12"></Form.Group>
                    </Row>

                    <Form.Label className='title-color'>Maisons</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox3">
                        <Form.Check id="can_manage_maisons" type="checkbox" ref="can_manage_maisons" label="Can manage Maisons" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox4">
                        <Form.Check id="can_manage_opening_input_period_per_Maisons" type="checkbox" ref="can_manage_opening_input_period_per_Maisons" label="Can manage opening input period per Maisons" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                    <Form.Group className="mb-3 col-md-12"></Form.Group>
                    </Row>

                    <Form.Label className='title-color'>Media References</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox5">
                        <Form.Check id="can_manage_airport_names" type="checkbox" ref="can_manage_airport_names" label="Can manage airport names" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox6">
                        <Form.Check id="can_manage_positions" type="checkbox" ref="can_manage_positions" label="Can manage positions" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox7">
                        <Form.Check id="can_manage_vehicles" type="checkbox" ref="can_manage_vehicles" label="Can manage vehicles" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>
                    
                    <Row>
                      <Form.Group controlId="formBasicCheckbox8">
                        <Form.Check id="can_manage_publishers_vendors" type="checkbox" ref="can_manage_publishers_vendors" label="Can manage publishers/vendors" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>
                  </div>

                  <div style={{marginLeft:'100px'}}>
                  <Form.Label className='title-color'>Geography</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox9">
                        <Form.Check id="can_manage_zone" type="checkbox" ref="can_manage_zone" label="Can manage zones" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox10">
                        <Form.Check id="can_manage_subzone" type="checkbox" ref="can_manage_subzone" label="Can manage subzones" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox11">
                        <Form.Check id="can_manage_country" type="checkbox" ref="can_manage_country" label="Can manage country/region" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                    <Form.Group className="mb-3 col-md-12"></Form.Group>
                    </Row>

                    <Form.Label className='title-color'>Exchange Rates</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox12">
                        <Form.Check id="can_manage_exchange_rate" type="checkbox" ref="can_manage_exchange_rate" label="Can manage exchange rates" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                    <Form.Group className="mb-3 col-md-12"></Form.Group>
                    </Row>

                    <Form.Label className='title-color'>User Administration</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox13">
                        <Form.Check id="can_manage_profiles" type="checkbox" ref="can_manage_profiles" label="Can manage profiles" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>
                    
                    <Row>
                      <Form.Group controlId="formBasicCheckbox14">
                        <Form.Check id="can_manage_users" type="checkbox" ref="can_manage_users" label="Can manage users" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox15">
                        <Form.Check id="can_manage_roles" type="checkbox" ref="can_manage_roles" label="Can manage roles" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>
                  </div>
                </div>
              </TabPanel>

              <TabPanel value="2" className='role-container font-size-12'>
                <Form.Label className='title-color'>Actions allowed</Form.Label>
                <Row>
                  <Form.Group controlId="formBasicCheckbox16">
                    <Form.Check id="can_access_budget_list" type="checkbox" ref="can_access_budget_list" label="Can access budget list" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group controlId="formBasicCheckbox17">
                    <Form.Check id="can_manage_budget_form" type="checkbox" ref="can_manage_budget_form" label="Can manage budget form" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>
              </TabPanel>

              <TabPanel value="3" className='role-container font-size-12'>
                <Form.Label className='title-color'>Actions allowed</Form.Label>
                <Row>
                  <Form.Group controlId="formBasicCheckbox18">
                    <Form.Check id="can_share_reports" type="checkbox" ref="can_share_reports" label="Can share reports" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group controlId="formBasicCheckbox19">
                    <Form.Check id="can_export_to_excel" type="checkbox" ref="can_export_to_excel" label="Can export to Excel" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group controlId="formBasicCheckbox20">
                    <Form.Check id="can_create_reports" type="checkbox" ref="can_create_reports" label="Can create reports" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group controlId="formBasicCheckbox21">
                    <Form.Check id="can_save_reports" type="checkbox" ref="can_save_reports" label="Can save reports" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>
              </TabPanel>
            </TabContext>
          </Box>
        </Modal.Body>
        <Modal.Footer>

        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateRole}>
            Create Role
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="roles" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >Edit Role</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-style'>This Role already exists, your updates cannot be saved.</p></Row>  } 
        {!this.state.editValidation && <Row className="mb-3 col-md-12"><p className='mandatory-style'>Mandatory fields are missing. Saving of the Role form is not allowed</p></Row>  }   
        {!this.state.roleValidation && <Row className="mb-3 col-md-12"><p className='mandatory-style'>At least one right has to be selected.</p></Row>  } 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.editValidation ? "normal-title" : "validation-title"} font-size-12`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="EditName" placeholder="Name" className={`${!this.state.editValidation && "validation-control"}`}/>
            </Form.Group>
            {!this.state.editValidation && <p className="p-required">Required</p>}
          </Row>

        <Row>
        <Form.Group className="mb-3 col-md-12"></Form.Group>
        </Row>

        <p className='set-right'>
          Set the rights that apply to this role among the tabs :
        </p>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={this.state.value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={this.handleChange} aria-label="tabs">
                  <Tab className='custom-tab' label="Administration" value="1" />
                  <Tab className='custom-tab' label="Inputting" value="2" />
                  <Tab className='custom-tab' label="Reporting" value="3" />
                </TabList>
              </Box>

              <TabPanel value="1" className='role-container'>
                <div className='display-flex'>
                  <div>
                    <Form.Label className='title-color'>Agencies</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox">
                        <Form.Check id="can_manage_agency" type="checkbox" ref="can_manage_agency" label="Can manage agencies" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox1">
                        <Form.Check id="can_manage_agency_fees" type="checkbox" ref="can_manage_agency_fees" label="Can manage agency fees" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox2">
                        <Form.Check id="can_manage_agency_network" type="checkbox" ref="can_manage_agency_network" label="Can manage agency networks" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                    <Form.Group className="mb-3 col-md-12"></Form.Group>
                    </Row>

                    <Form.Label className='title-color'>Maisons</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox3">
                        <Form.Check id="can_manage_maisons" type="checkbox" ref="can_manage_maisons" label="Can manage Maisons" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox4">
                        <Form.Check id="can_manage_opening_input_period_per_Maisons" type="checkbox" ref="can_manage_opening_input_period_per_Maisons" label="Can manage opening input period per Maisons" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                    <Form.Group className="mb-3 col-md-12"></Form.Group>
                    </Row>

                    <Form.Label className='title-color'>Media References</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox5">
                        <Form.Check id="can_manage_airport_names" type="checkbox" ref="can_manage_airport_names" label="Can manage airport names" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox6">
                        <Form.Check id="can_manage_positions" type="checkbox" ref="can_manage_positions" label="Can manage positions" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox7">
                        <Form.Check id="can_manage_vehicles" type="checkbox" ref="can_manage_vehicles" label="Can manage vehicles" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>
                    
                    <Row>
                      <Form.Group controlId="formBasicCheckbox8">
                        <Form.Check id="can_manage_publishers_vendors" type="checkbox" ref="can_manage_publishers_vendors" label="Can manage publishers/vendors" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>
                  </div>

                  <div style={{marginLeft:'100px'}}>
                  <Form.Label className='title-color'>Geography</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox9">
                        <Form.Check id="can_manage_zone" type="checkbox" ref="can_manage_zone" label="Can manage zones" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox10">
                        <Form.Check id="can_manage_subzone" type="checkbox" ref="can_manage_subzone" label="Can manage subzones" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox11">
                        <Form.Check id="can_manage_country" type="checkbox" ref="can_manage_country" label="Can manage country/region" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                    <Form.Group className="mb-3 col-md-12"></Form.Group>
                    </Row>

                    <Form.Label className='title-color'>Exchange Rates</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox12">
                        <Form.Check id="can_manage_exchange_rate" type="checkbox" ref="can_manage_exchange_rate" label="Can manage exchange rates" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                    <Form.Group className="mb-3 col-md-12"></Form.Group>
                    </Row>

                    <Form.Label className='title-color'>User Administration</Form.Label>
                    <Row>
                      <Form.Group controlId="formBasicCheckbox13">
                        <Form.Check id="can_manage_profiles" type="checkbox" ref="can_manage_profiles" label="Can manage profiles" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>
                    
                    <Row>
                      <Form.Group controlId="formBasicCheckbox14">
                        <Form.Check id="can_manage_users" type="checkbox" ref="can_manage_users" label="Can manage users" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group controlId="formBasicCheckbox15">
                        <Form.Check id="can_manage_roles" type="checkbox" ref="can_manage_roles" label="Can manage roles" onChange={this.saveChkState} />
                      </Form.Group>
                    </Row>
                  </div>
                </div>
              </TabPanel>

              <TabPanel value="2" className='role-container'>
                <Form.Label className='title-color'>Actions allowed</Form.Label>
                <Row>
                  <Form.Group controlId="formBasicCheckbox16">
                    <Form.Check id="can_access_budget_list" type="checkbox" ref="can_access_budget_list" label="Can access budget list" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group controlId="formBasicCheckbox17">
                    <Form.Check id="can_manage_budget_form" type="checkbox" ref="can_manage_budget_form" label="Can manage budget form" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>
              </TabPanel>

              <TabPanel value="3" className='role-container'>
                <Form.Label className='title-color'>Actions allowed</Form.Label>
                <Row>
                  <Form.Group controlId="formBasicCheckbox18">
                    <Form.Check id="can_share_reports" type="checkbox" ref="can_share_reports" label="Can share reports" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group controlId="formBasicCheckbox19">
                    <Form.Check id="can_export_to_excel" type="checkbox" ref="can_export_to_excel" label="Can export to Excel" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group controlId="formBasicCheckbox20">
                    <Form.Check id="can_create_reports" type="checkbox" ref="can_create_reports" label="Can create reports" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group controlId="formBasicCheckbox21">
                    <Form.Check id="can_save_reports" type="checkbox" ref="can_save_reports" label="Can save reports" onChange={this.saveChkState} />
                  </Form.Group>
                </Row>
              </TabPanel>
            </TabContext>
          </Box>
        </Modal.Body>

        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditRole}>
            Update Role
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal>

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>
      
      <ConfirmationDelete show={this.state.showConfirmationDelete} hide={this.hideConfirmationDelete} confirm={this.onCatchDelete} title="Delete Role" msg="Are you sure you want to delete this Role ?"/>

      <ToastContainer position="bottom-right"/>  
      </div>
    );
  }
  onShowFilterRowChanged(e) {
    this.setState({
      showFilterRow: e.value
    });
    this.clearFilter();
  }
  onShowHeaderFilterChanged(e) {
    this.setState({
      showHeaderFilter: e.value
    });
    this.clearFilter();
  }
  onCurrentFilterChanged(e) {
    this.setState({
      currentFilter: e.value
    });
  }
  clearFilter() {
    this.dataGrid.clearFilter();
  }
}

export default Role;